import { render, staticRenderFns } from "./calculator_tax.vue?vue&type=template&id=3d361ff6&scoped=true"
import script from "./calculator_tax.vue?vue&type=script&lang=js"
export * from "./calculator_tax.vue?vue&type=script&lang=js"
import style0 from "./calculator_tax.vue?vue&type=style&index=0&id=3d361ff6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d361ff6",
  null
  
)

export default component.exports